(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsen-link/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsen-link/assets/javascripts/utils.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const SportinfoPathNames = svs.components.sportinfo.common.constants.SportinfoPathNames;
const baseUrl = svs.core.data.baseUrl;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const validBigStatPaths = [TipsenModuleGameUrl.STANDARD, TipsenModuleGameUrl.SYSTEM, TipsenModuleGameUrl.TIPS_SM, TipsenModuleGameUrl.TIPS_EM];
const validBigStatPathNames = Object.values(SportinfoPathNames);
const getEventLink = () => {
  const relativeUrl = location.pathname.slice(baseUrl.length).slice(1);
  const _relativeUrl$split = relativeUrl.split('/'),
    _relativeUrl$split2 = _slicedToArray(_relativeUrl$split, 2),
    first = _relativeUrl$split2[0],
    second = _relativeUrl$split2[1];
  let href = location.pathname.slice(baseUrl.length);
  if (!validBigStatPaths.includes(first) && !validBigStatPathNames.includes(first) || validBigStatPaths.includes(first) && !validBigStatPathNames.includes(second)) {
    if (validBigStatPaths.includes(first)) {
      href = "/".concat(first);
    } else {
      href = "/".concat(TipsenModuleGameUrl.STANDARD);
    }
  }
  return href;
};
setGlobal('svs.components.tipsen.tipsen_link.utils', {
  getEventLink
});

 })(window);